// @docs https://[domain]/api/v1/docs
export default {
  Login: "/auth/login",
  Logout: "/auth/logout",
  UserInfo: "/auth/userinfo",
  RefreshToken: "/auth/refresh",
  GenerateOTP: "/otps/generate",
};
